/**
 * @param {number[]} data - array of numbers to calculate chart step size
 *
 * @returns {(number|null)} - the step size as a number or null (to default to chartjs calculations)
 */

export const getStepSize = (data) => {
  const average = data.reduce((i, sum) => (i + sum), 0) / data.length
  if (average < 5) {
    return 1
  }

  if (average < 10) {
    return 5
  }

  if (average < 20) {
    return 10
  }

  if (average < 50) {
    return 20
  }

  if (average < 1000) {
    return 50
  }

  return null
}

/**
 * @param {boolean} isAdminOrOwner - is current user an organization admin or an organization owner
 * @param {boolean} isUserGroupAdmin - is current user a user group admin
 * @param {number | undefined} userGroupId - id of the user group user belongs to
 *
 * @returns {(string)} - the name of the scope
 */
export const getEventsScope = ({ isAdminOrOwner, isUserGroupAdmin, userGroupId }) => {
  if (isAdminOrOwner) {
    return 'all_users_and_teams'
  }

  if (isUserGroupAdmin && userGroupId) {
    return `user_group/${userGroupId}`
  }

  return 'user/me'
}

/**
 * @param {number} absolutePercentDiff - decimal to be transformed
 *
 * @returns {(string)} - returns a %number
 */

export const getPercentText = (absolutePercentDiff) => new Intl.NumberFormat(undefined, {
  style: 'unit',
  unit: 'percent',
  maximumFractionDigits: absolutePercentDiff > 0.1 ? 1 : 2
}).format(
  absolutePercentDiff * 100
)
